import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import EmpresaInfoForm from './upsert/components/EmpresaInfoForm';
import { TheError, TheResult } from '../../shared/responses/TheResult';
import EmpresaCustomization from './upsert/components/EmpresaCustomization';

class EmpresasUpsert extends Component {
  state = {
    data: {},
  };

  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      ...this.state,
      data: { id },
    };
  }

  async componentDidMount() {
    const { data } = this.state;

    let info = await this.props.info(data.id, { include: 'config' });

    !!info && this.props.setData(info);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleOnConfirm = async () => {
    const { data } = this.props;

    let body = {};

    try {
      body = {
        nombre: data.nombre,
        host: data.host,
        config: typeof data.config === 'string' ? JSON.parse(data.config) : undefined,
      };
    } catch (error) {
      window.ToastManager.show({
        variant: 'danger',
        title: '❌ Error al parsear JSON:',
        message: error.message,
      });
    }

    let result = null;

    if (data.id) {
      result = await this.props.upsert(body, data.id);
    } else {
      result = await this.props.upsert(body);
    }

    if (!!result) {
      window.ToastManager.show({
        variant: 'success',
        title: 'Empresas',
        message: result.message || (!this.state.data.id ? 'Empresa registrada' : 'Información actualizada'),
      });

      this.props.highlight(result.data);

      this.props.history.replace('/cuenta/empresas');
    }
  };

  handleOnDataChange = (event) => {
    const data = {
      data: {
        ...this.props.data,
        ...event.data,
      },
      error: undefined,
      result: undefined,
      isValid: event.isValid,
    };

    this.props.change(data);
  };

  handleOnAction = (action) => {
    if (action === 'confirm') {
      const { id } = this.state.data;

      if (!!id) {
        this.props.history.replace({
          pathname: `/cuenta/empresas/${id}/info`,
          state: {
            data: this.props.empresa,
          },
        });
      } else {
        this.props.history.replace(`/cuenta/empresas`);
      }
    }
  };

  handleOnLogoUpdated = async (data) => {
    const { empresa } = this.props;

    if (!!empresa) {
      let info = await this.props.info(empresa.id, { include: 'config' });

      !!info && this.props.setData(info);
    }
  };

  render() {
    const { data = {}, error, result, isValid, busy, fetching } = this.props;

    if (fetching) {
      return <Loading />;
    }

    return (
      <>
        {!!error && <TheError error={error} />}

        {!!result && <TheResult result={result} />}

        <div className="page-header">
          <Link to="/cuenta/empresas">&#8592; Todas mis empresas</Link>
        </div>

        <h5>{data.id ? data.nombre || '...' : 'Nueva Empresa'}</h5>

        <EmpresaInfoForm
          data={data}
          autoFocus={true}
          onFormDataChange={this.handleOnDataChange}
        />

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <EmpresaCustomization
              empresa={{ ...data }}
              onLogoUpdated={this.handleOnLogoUpdated}
            />
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <PopConfirm
              text="Realmente deseas cancelar?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
              >
                Cancelar
              </Button>
            </PopConfirm>{' '}
            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnConfirm}
            >
              {!!data.id ? (busy ? 'Actualizando...' : 'Guardar') : ''}
              {!data.id ? (busy ? 'Registrando...' : 'Registrar') : ''}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.cuenta.empresas.upsert,
    empresa: state.cuenta.empresas.info.data,
    fetching: state.cuenta.empresas.info.busy,
  };
};

const mapActions = (actions) => {
  return {
    ...actions.cuenta.empresas.upsert,
    info: actions.cuenta.empresas.info.get,
    highlight: actions.cuenta.empresas.list.highlight,
  };
};

export default connect(useStore, mapState, mapActions)(EmpresasUpsert);
